import React from "react";

function Impressum() {
  return (
    <div className="impressum">
      <div className="content">
        <div className="container">
          <h1>Impressum</h1>
          <h3>Address</h3>
          <p>
            BRICS - Braunschweig Integrated Centre of Systems Biology <br />
            Technische Universität Braunschweig <br />
            Rebenring 56 <br />
            D-38106 Braunschweig <br />
            Germany
          </p>
          <h3>Contact</h3>
          <p>
            Collin Starke <br />
            E-Mail: c.starke@tu-bs.de
          </p>
        </div>
      </div>
    </div>
  );
}

export default Impressum;
